export function boolean(proto, key) {
    var alias = "_" + key;
    Object.defineProperty(proto, key, {
        get: function () {
            return this[alias];
        },
        set: function (val) {
            Object.defineProperty(this, alias, {
                value: !!val,
                enumerable: false,
                writable: true,
                configurable: true,
            });
        },
        enumerable: true,
        configurable: true,
    });
}
//# sourceMappingURL=boolean.js.map


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_rich_media/node_modules/smooth-scrollbar/decorators/boolean.js
// module id = 682
// module chunks = 0